module.exports = __webpack_public_path__ + "src/assets/img/livejournal.7d9c4a84.jpg";